// Seattle University's majors (#2740). Read on 2026-10-01 from the official
// Seattle University 2026-2027 Undergraduate Catalog (catalog.seattleu.edu),
// Academic Programs by Colleges and Schools: every bachelor's degree program
// each college lists, with the degree as the catalog writes it, and
// specializations listed as their own programs where the catalog lists them
// that way (Environment and Sustainability, Interdisciplinary Arts, Civil
// Engineering, Criminal Justice and Criminology, Political Science). Cornish
// College of the Arts is part of Seattle University; its Bachelor of Music is
// shown as Music. Left out: the Departmental Honors and University Honors
// Program versions of majors, the Criminal Justice and Criminology BA/MA,
// minors, certificates, accelerated degree programs, ROTC and military
// science, Contemporary Issues in Social Science (a set of courses), and the
// University Honors Program itself.
const majors = {
    "slug": "seattle-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in Seattle University's official 2026-2027 undergraduate catalog, grouped by the college or school that offers it, including Cornish College of the Arts. Honors versions of majors, minors, certificates and accelerated programs are left out.",
    "groups": [
        {
            "name": "Cornish College of the Arts",
            "source": {
                "label": "Seattle University 2026-2027 Undergraduate Catalog, Cornish College of the Arts",
                "url": "https://catalog.seattleu.edu/content.php?catoid=61&navoid=6340"
            },
            "majors": [
                {
                    "name": "Acting & Original Works",
                    "degree": "BFA"
                },
                {
                    "name": "Animation",
                    "degree": "BFA"
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Music",
                    "degree": "Bachelor of Music"
                },
                {
                    "name": "Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Design",
                    "degree": "BFA"
                },
                {
                    "name": "Film",
                    "degree": "BFA"
                },
                {
                    "name": "Game Art",
                    "degree": "BFA"
                },
                {
                    "name": "Illustration",
                    "degree": "BFA"
                },
                {
                    "name": "Interaction Design",
                    "degree": "BFA"
                },
                {
                    "name": "Musical Theater",
                    "degree": "BFA"
                },
                {
                    "name": "Performance Production",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Seattle University 2026-2027 Undergraduate Catalog, College of Arts and Sciences",
                "url": "https://catalog.seattleu.edu/content.php?catoid=61&navoid=6109"
            },
            "majors": [
                {
                    "name": "Anthropology and Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Art and Visual Culture Studies",
                    "degree": "BA"
                },
                {
                    "name": "Asian and Asian American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication and Media",
                    "degree": "BA"
                },
                {
                    "name": "Criminal Justice and Criminology with a Specialization in Law",
                    "degree": "BA"
                },
                {
                    "name": "Criminal Justice and Criminology",
                    "degree": "BA"
                },
                {
                    "name": "Design",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "English/Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "Environment and Sustainability with a Specialization in Ecological Systems",
                    "degree": "BS"
                },
                {
                    "name": "Environment and Sustainability with a Specialization in Environmental Education and Communication",
                    "degree": "BA"
                },
                {
                    "name": "Environment and Sustainability with a Specialization in Politics, Policy, and Justice",
                    "degree": "BA"
                },
                {
                    "name": "Environment and Sustainability with a Specialization in Urban Sustainability",
                    "degree": "BA"
                },
                {
                    "name": "Environment and Sustainability",
                    "degree": "BA"
                },
                {
                    "name": "Film and Media",
                    "degree": "BA"
                },
                {
                    "name": "Forensic Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Forensic Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Forensic Science",
                    "degree": "BS"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Humanities for Teaching",
                    "degree": "BA"
                },
                {
                    "name": "Humanities",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Arts with a Specialization in Arts Leadership",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Arts with a Specialization in Music",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Arts with a Specialization in Photography",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Arts with a Specialization in Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Arts with a Specialization in Visual Art",
                    "degree": "BA"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Photography",
                    "degree": "BFA"
                },
                {
                    "name": "Political Science with Specialization in Legal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Public Affairs",
                    "degree": "BA"
                },
                {
                    "name": "Social Work",
                    "degree": "BSW"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Theology and Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Women, Gender, and Sexuality Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Albers School of Business and Economics",
            "source": {
                "label": "Seattle University 2026-2027 Undergraduate Catalog, Albers School of Business and Economics",
                "url": "https://catalog.seattleu.edu/content.php?catoid=61&navoid=6110"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BABA"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BABA"
                },
                {
                    "name": "Business and Law",
                    "degree": "BABA"
                },
                {
                    "name": "Business Economics",
                    "degree": "BABA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Finance",
                    "degree": "BABA"
                },
                {
                    "name": "Individualized Major in Business Administration",
                    "degree": "BABA"
                },
                {
                    "name": "Management",
                    "degree": "BABA"
                },
                {
                    "name": "Marketing",
                    "degree": "BABA"
                }
            ]
        },
        {
            "name": "College of Nursing and Health Sciences",
            "source": {
                "label": "Seattle University 2026-2027 Undergraduate Catalog, College of Nursing and Health Sciences",
                "url": "https://catalog.seattleu.edu/content.php?catoid=61&navoid=6094"
            },
            "majors": [
                {
                    "name": "Diagnostic Ultrasound",
                    "degree": "BS"
                },
                {
                    "name": "Kinesiology",
                    "degree": "BS"
                },
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "College of Science and Engineering",
            "source": {
                "label": "Seattle University 2026-2027 Undergraduate Catalog, College of Science and Engineering",
                "url": "https://catalog.seattleu.edu/content.php?catoid=61&navoid=6095"
            },
            "majors": [
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Cell and Molecular Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering with a Specialization in Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Marine and Conservation Biology",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
